var map = {
	"./10label.png": "cNb7",
	"./10title.png": "5Ihx",
	"./11label.png": "G/kR",
	"./11title.png": "jPxM",
	"./1label.png": "mB5d",
	"./1title.png": "PIxi",
	"./2label.png": "Mq+E",
	"./2title.png": "awkP",
	"./3label.png": "9zbK",
	"./3title.png": "GnnE",
	"./4label.png": "OBId",
	"./4title.png": "xHlN",
	"./5label.png": "v+DN",
	"./5title.png": "8o6E",
	"./6label.png": "oDAy",
	"./6title.png": "ke7c",
	"./7label.png": "k/JG",
	"./7title.png": "TwFV",
	"./8label.png": "kc1k",
	"./8title-2.png": "g85+",
	"./9label.png": "ZygE",
	"./9title.png": "SvaR",
	"./gift.png": "Xrox",
	"./textlogo.png": "lf+k"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CBha";